<template>
    <div>
        <div v-if="localIsInCompare" class="item"><img class="item__icon" :src="this.localBaseUrl + '/img/compare_on.png'" alt=""/>
            <a @click="removeFromCompare" class="item__link js-sidebar-open" href="#">В сравнении</a>
        </div>
        <div v-else class="item"><img class="item__icon" :src="this.localBaseUrl + '/img/compare_off.png'" alt=""/>
            <a @click="addToCompare" class="item__link js-sidebar-open" href="#">В сравнение</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "product-compare",
        props: {
            product_id: {
                type: Number
            },
            baseurl: {
                type: String
            },
            is_incompare: {
              type: Boolean,
            }
        },
        data() {
            return {
                localProductId: this.product_id,
                localBaseUrl: this.baseurl,
                //localIsInCompare: false,
                localIsInCompare: this.is_incompare
            }
        },
        methods: {
            addToCompare(e) {
                e.preventDefault();
                let params = new URLSearchParams();
                params.append('action', 'addToCompare');
                params.append('product_id', this.localProductId);
                axios.post('/rest/product', params)
                    .then((response) => {
                        const data = JSON.parse(response.data);
                        this.localIsInCompare = data;

                        this.$store.dispatch('getCompareInfo', {product_id: this.localProductId, option: 1, is_ok: data})

                    }).catch(error => console.log(error))
            },
            removeFromCompare(e) {
                e.preventDefault();
                let params = new URLSearchParams();
                params.append('action', 'removeFromCompare');
                params.append('product_id', this.localProductId);
                axios.delete('/rest/product', {data:params})
                    .then((response) => {
                        const data = JSON.parse(response.data);
                        this.localIsInCompare = data;

                        this.$store.dispatch('getCompareInfo',{product_id: this.localProductId, option: 0, is_ok: true})

                    }).catch(error => console.log(error))
            }
        },
        /*created() {
            let params = new URLSearchParams();
            params.append('action', 'isInCompare');
            params.append('product_id', this.localProductId);
            axios.get('/rest/product', {params})
                .then((response) => {
                    const data = JSON.parse(response.data);
                    this.localIsInCompare = data;
                }).catch(error => console.log(error))
        }*/
    }
</script>

<style scoped>

</style>